module.exports = __webpack_public_path__ + "static/img/i创杯 获奖证书_1.701b1669.jpg";